import { render, staticRenderFns } from "./CreateAccountsDialog.vue?vue&type=template&id=2a21f7d6&"
import script from "./CreateAccountsDialog.vue?vue&type=script&lang=js&"
export * from "./CreateAccountsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports